/* KP 29-09-2026: kleine melding na toevoegen aan de winkelwagen (vervangt de pop-up).
 * Luistert naar elk geslaagd POST /cart/add(.js) via fetch en XMLHttpRequest, dus alle toevoegplekken
 * (productpagina, plakkende knop, snelle weergave, apps). Antwoorden worden niet gewijzigd.
 * Daarna één /cart.js (locale-bewust) voor de teller en de vertaalde productnaam.
 * Geen opstapeling: één element, de laatste melding vervangt de vorige en de 3 s-timer begint opnieuw.
 */
(function () {
  'use strict';
  if (window.__kpToevoegMelding) return;
  window.__kpToevoegMelding = true;

  var TOON_MS = 3000;
  var ADD_RE = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var el = null, timer = null, volg = 0;

  function toast() { return el || (el = document.getElementById('kp-toast')); }
  function opWinkelwagen() { return document.body && document.body.classList.contains('template-cart'); }
  function tekst(s) { return String(s == null ? '' : s); }

  function onderkop() {
    // Onderkant van de zichtbare (plakkende) kop, zodat de melding eronder valt. Alleen lezen, niets verschuift.
    var max = 0;
    document.querySelectorAll('.shopify-section-group-header-group, header.header, sticky-header').forEach(function (h) {
      var r = h.getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0 && r.top < window.innerHeight * 0.4) max = Math.max(max, r.bottom);
    });
    return Math.round(Math.min(max, window.innerHeight * 0.4)) + 12;
  }

  function bovenBalken() {
    // Hoogte van vaste balken onderaan (plakkende toevoegknop, plakkende afrekenknop, werkbalk): de melding komt erboven.
    var max = 0, h = window.innerHeight, gezien = [];
    [0.25, 0.5, 0.75].forEach(function (fx) {
      var lijst = document.elementsFromPoint ? document.elementsFromPoint(window.innerWidth * fx, h - 4) : [];
      lijst.forEach(function (n) {
        for (var e = n; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
          if (gezien.indexOf(e) !== -1 || (el && (e === el || el.contains(e)))) continue;
          gezien.push(e);
          var cs = getComputedStyle(e);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          var r = e.getBoundingClientRect();
          if (r.top > h * 0.5 && r.bottom >= h - 6 && r.width > window.innerWidth * 0.5) max = Math.max(max, h - r.top);
        }
      });
    });
    return Math.round(max) + 12;
  }

  function verberg() {
    var t = toast();
    if (!t) return;
    clearTimeout(timer); timer = null;
    t.classList.remove('is-open');
  }

  function planVerbergen() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var t = toast();
      if (t && t.contains(document.activeElement)) { planVerbergen(); return; } // toetsenbord: niet wegtrekken onder de focus
      verberg();
    }, TOON_MS);
  }

  function toon(naam, variant) {
    var t = toast();
    if (!t) return;
    t.style.setProperty('--kp-toast-top', onderkop() + 'px');
    t.style.setProperty('--kp-toast-bottom', bovenBalken() + 'px');
    var kop = document.createElement('span'); kop.className = 'kp-toast__kop'; kop.textContent = t.getAttribute('data-t-added');
    var n = document.createElement('span'); n.className = 'kp-toast__naam'; n.textContent = tekst(naam);
    var v = document.createElement('span'); v.className = 'kp-toast__variant'; v.textContent = tekst(variant);
    var a = document.createElement('a'); a.className = 'kp-toast__link'; a.href = t.getAttribute('data-cart-url') || '/cart'; a.textContent = t.getAttribute('data-t-view');
    t.classList.add('is-open');
    // Inhoud pas na het zichtbaar maken vervangen, zodat schermlezers de wijziging voorlezen.
    requestAnimationFrame(function () { t.replaceChildren(kop, n, v, a); });
    planVerbergen();
  }

  function flitsTeller() {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      var d = c.closest('.cart-count-bubble') || c;
      d.classList.remove('kp-teller-flits');
      void d.offsetWidth; // animatie opnieuw starten
      d.classList.add('kp-teller-flits');
      setTimeout(function () { d.classList.remove('kp-teller-flits'); }, 1400);
    });
  }

  function zetTeller(n) {
    var s = window.cartStrings || {};
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = (n >= 100 && s.item_99 && c.closest('.cart-count-bubble')) ? s.item_99 : n;
    });
    document.querySelectorAll('[data-cart-text]').forEach(function (c) {
      if (s.item && s.items) c.textContent = n === 1 ? s.item : s.items;
    });
  }

  function variantTekst(i) {
    if (!i || i.product_has_only_default_variant) return '';
    var v = i.variant_title;
    return v && v !== 'Default Title' ? v : '';
  }

  function naToevoegen(antw) {
    if (opWinkelwagen() || !toast()) return;
    var items = antw && Array.isArray(antw.items) ? antw.items : (antw && antw.id ? [antw] : []);
    var laatste = items[items.length - 1] || null;
    var mijn = ++volg;
    if (laatste) toon(laatste.product_title || laatste.title, variantTekst(laatste));
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    _fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (mijn !== volg) return; // een nieuwere toevoeging is al onderweg
        zetTeller(cart.item_count);
        flitsTeller();
        var i = null;
        if (laatste) for (var k = 0; k < cart.items.length; k++) if (cart.items[k].key === laatste.key) { i = cart.items[k]; break; }
        if (i) {
          var t = toast();
          var naam = t && t.querySelector('.kp-toast__naam'), v = t && t.querySelector('.kp-toast__variant');
          if (naam && naam.textContent !== tekst(i.product_title)) naam.textContent = tekst(i.product_title);
          if (v && v.textContent !== variantTekst(i)) v.textContent = variantTekst(i);
        } else if (!laatste) {
          var l = cart.items[0];
          if (l) toon(l.product_title, variantTekst(l));
        }
      })
      .catch(function () {});
  }

  function isAdd(url, method) {
    return String(method || 'GET').toUpperCase() === 'POST' && ADD_RE.test(String(url || '').split('#')[0]);
  }

  // fetch
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
    var p = _fetch.apply(window, arguments);
    if (isAdd(url, method)) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        r.clone().json().then(naToevoegen).catch(function () { naToevoegen(null); });
      }).catch(function () {});
    }
    return p;
  };

  // XMLHttpRequest (jQuery $.ajax in theme.js)
  var X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (X) {
    var _open = X.open;
    X.open = function (method, url) {
      try {
        if (isAdd(url, method) && !this.__kpAdd) {
          this.__kpAdd = true;
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            var j = null;
            try { j = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); } catch (e) {}
            naToevoegen(j);
          });
        }
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  // Klik of tik ernaast: direct weg. Escape ook. Een klik op een toevoegknop telt niet: dan vervangt de nieuwe melding
  // de huidige zonder eerst te knipperen.
  var TOEVOEGKNOP = 'button[name="add"], [data-btn-addtocart], #preorder-backorder-btn';
  document.addEventListener('pointerdown', function (e) {
    var t = toast();
    if (!t || !t.classList.contains('is-open') || t.contains(e.target)) return;
    if (e.target && e.target.closest && e.target.closest(TOEVOEGKNOP)) return;
    verberg();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') verberg(); });
})();
